import React, { useState, useEffect } from "react";
import "./Navbar.css";

const links = ["About", "Education", "Skills", "Projects", "Contact"];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("Home");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const scrollPosition = window.scrollY + 150;
      let current = "Home";
      links.forEach((link) => {
        const section = document.getElementById(link.toLowerCase());
        if (section && section.offsetTop <= scrollPosition) {
          current = link;
        }
      });
      setActiveSection(current);
    };

    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (section) => {
    setMenuOpen(false);
    document.getElementById(section.toLowerCase())?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <a href="#hero" className="navbar__logo" onClick={() => setMenuOpen(false)}>
        Bishoy<span>.</span>
      </a>

      <div className="navbar__section-name">{activeSection}</div>

      <ul className="navbar__links">
        {links.map((l) => (
          <li key={l}>
            <button onClick={() => handleNav(l)}>{l}</button>
          </li>
        ))}
      </ul>

      <button
        className={`navbar__burger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen((v) => !v)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span /><span /><span />
      </button>

      <div className={`navbar__mobile ${menuOpen ? "navbar__mobile--open" : ""}`}>
        <button className="navbar__mobile-close" onClick={() => setMenuOpen(false)} aria-label="Close menu">
          Close
        </button>
        <div className="navbar__mobile-links">
          {links.map((l) => (
            <button key={l} onClick={() => handleNav(l)}>{l}</button>
          ))}
        </div>
      </div>
    </nav>
  );
}
